import { useNavigate } from "react-router-dom";
import { FileBarChart2 } from "lucide-react";

/* Bouton « Créer un reporting » — relie automatiquement le reporting au module de la page */
export function CreateReportButton({ module, className = "" }) {
  const nav = useNavigate();
  return (
    <button onClick={() => nav(`/reports?new=${module}`)} data-testid={`create-report-${module}`}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-orange-200 bg-orange-50 text-orange-700 text-xs font-semibold hover:bg-orange-100 transition-colors ${className}`}>
      <FileBarChart2 className="w-3.5 h-3.5"/> Créer un reporting
    </button>
  );
}
